import {
  Button,
  Form,
  Input,
  Typography,
  Select,
  message,
  Radio,
  Divider,
  Space,
  Checkbox,
} from "antd";
import { Modal } from "antd";

import {
  EditOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, getCompanies } from "../../services/userDataService";
import { addOrder } from "../../state/reducers/orderSlice";
import { createOrder, newOrder } from "../../services/orderService";
import { useNavigate } from "react-router-dom";
import { clearCart } from "../../services/cartDataService";
import { clearCartItems } from "../../state/reducers/cartSlice";

const { Title } = Typography;
const { Option } = Select;

const CreateOrderForm = ({ handleClick }) => {
  const token = useSelector((state) => state.user.token);
  const user = useSelector((state) => state.user.user);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [managers, setManagers] = useState([]);
  const [selectedManagerId, setSelectedManagerId] = useState(null);
  const [sales, setSales] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null); // To hold the selected user's data
  const [isAddingBilling, setIsAddingBilling] = useState(true);
  const [isEditing, setIsEditing] = useState(false); // Track if editing
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(null); // Index of address being edited
  const [sameAsBillingExisting, setSameAsBillingExisting] = useState(false);
  const [sameAsBillingNew, setSameAsBillingNew] = useState(false);

  const customerUser = useSelector((state) => state.user.user);
  const role = useSelector((state) => state.user.role);
  const [form] = Form.useForm();
  const [newForm] = Form.useForm();
  const [customerType, setCustomerType] = useState("existing");
  const [entityType, setEntityType] = useState("customer"); // New state for entity type
  const [companies, setCompanies] = useState([]);
  const [newCompany, setNewCompany] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [newAddress, setNewAddress] = useState({
    line1: "",
    line2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    default: true,
    // isDefault: true,
  });

  const handleSameAsBillingChangeExisting = (e) => {
    setSameAsBillingExisting(e.target.checked);

    if (e.target.checked) {
      // Copy billing address to shipping address
      const billingAddresses = form.getFieldValue("billingAddress") || [];

      if (billingAddresses.length > 0) {
        form.setFieldsValue({
          shippingAddress: [...billingAddresses], // Clone billing addresses to shipping
        });
      }
    } else {
      form.setFieldsValue({ shippingAddress: selectedUser.shippingAddress });
    }
  };

  const handleSameAsBillingChangeNew = (e) => {
    setSameAsBillingNew(e.target.checked);

    if (e.target.checked) {
      // Copy billing address to shipping address
      const billingAddresses = newForm.getFieldValue("billingAddress") || [];

      if (billingAddresses.length > 0) {
        newForm.setFieldsValue({
          shippingAddress: [...billingAddresses], // Clone billing addresses to shipping
        });
      }
    } else {
      newForm.setFieldsValue({ shippingAddress: [] });
    }
  };

  const handleEditAddress = (index, field) => {
    let addressToEdit;

    if (field === "address") {
      // If editing the main address
      addressToEdit =
        customerType === "existing"
          ? form.getFieldValue("address") || {}
          : newForm.getFieldValue("address") || {};
    } else {
      // If editing billing or shipping address
      const currentAddresses =
        customerType === "existing"
          ? form.getFieldValue(field) || []
          : newForm.getFieldValue(field) || [];

      addressToEdit = currentAddresses[index];
    }

    setNewAddress(addressToEdit); // Load the address into the modal fields
    setIsEditing(true);
    setSelectedAddressIndex(index);
    setIsAddingBilling(field === "billingAddress");
    setIsModalOpen(true);
  };

  // const handleEditAddress = (index, field) => {
  //   // Get the current addresses based on the field
  //   const currentAddresses =
  //     customerType === "existing"
  //       ? form.getFieldValue(field) || []
  //       : newForm.getFieldValue(field) || [];

  //   const addressToEdit = currentAddresses[index];

  //   setNewAddress(addressToEdit); // Load the address into the modal fields
  //   setIsEditing(true);
  //   setIsAddingBilling(field === "billingAddress");
  //   setSelectedAddressIndex(index);
  //   setIsModalOpen(true);
  // };

  const handleAddressSelect = (selectedIndex, fieldName, formInstance) => {
    const addresses = formInstance.getFieldValue(fieldName) || [];

    // Update all addresses, setting only one as `default: true`
    const updatedAddresses = addresses.map((addr, index) => ({
      ...addr,
      default: index === parseInt(selectedIndex.split("-")[1]) ? true : false, // Set only selected one as default
    }));

    // Update form fields
    formInstance.setFieldsValue({
      [fieldName]: updatedAddresses,
      [`${fieldName}Selected`]: selectedIndex, // Store selected index for UI
    });

    console.log(`${fieldName} updated:`, updatedAddresses);
  };

  const handleModalOk = () => {
    if (
      !newAddress.line1 ||
      !newAddress.city ||
      !newAddress.state ||
      !newAddress.country
    ) {
      message.error("Please fill all required fields!");
      return;
    }

    const activeForm = customerType === "existing" ? form : newForm;
    const fieldToUpdate = isAddingBilling
      ? "billingAddress"
      : "shippingAddress";
    const currentAddresses = activeForm.getFieldValue(fieldToUpdate) || [];

    let updatedAddresses;

    if (isEditing && selectedAddressIndex !== null) {
      // If editing an existing address, update it in the list
      updatedAddresses = currentAddresses.map((addr, index) =>
        index === selectedAddressIndex ? newAddress : addr
      );
    } else {
      // If adding a new address, append it to the list
      updatedAddresses = [...currentAddresses, newAddress];
    }

    // Set the updated addresses in the form
    activeForm.setFieldsValue({ [fieldToUpdate]: updatedAddresses });

    // Reset state after saving
    setNewAddress({
      line1: "",
      line2: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
    });

    setIsEditing(false);
    setSelectedAddressIndex(null);
    setIsModalOpen(false);

    message.success(isEditing ? "Address Updated!" : "New Address Added!");
  };

  const handleCustomerTypeChange = (e) => {
    setCustomerType(e.target.value);
  };

  const handleEntityTypeChange = (value) => {
    setEntityType(value); // Update entity type based on selection
  };

  console.log(selectedUser);

  const onCompanyChange = (event) => {
    setNewCompany(event.target.value);
  };

  const handleManagerSelect = async (value) => {
    setSelectedManagerId(value); // Store the selected Sales Manager ID
    const res = await getAllUsers("sales", token);

    // Filter sales reps under the selected manager
    const filteredSales = res.data.data.filter(
      (user) => user.salesManager && user.salesManager.id === value
    );

    setSales(filteredSales);

    // Automatically set the first Sales Person as default (if available)
    if (filteredSales.length > 0) {
      newForm.setFieldsValue({ salesPerson: filteredSales[0].id });
    }
  };

  const onFinish = async (values) => {
    try {
      const billingAddresses = form.getFieldValue("billingAddress") || [];
      const shippingAddresses = form.getFieldValue("shippingAddress") || [];
      const orderAddress = form.getFieldValue("address") || [];
      console.log(orderAddress);
      const orderData = {
        ...values,
        orderAddress,
        billingAddress: billingAddresses, // Pass all billing addresses
        shippingAddress: shippingAddresses, // Pass all shipping addresses
      };
      // console.log(orderData);

      console.log(orderData);
      const res = await createOrder(
        token,
        orderData,
        orderData.id,
        orderData.phone
      );

      if (res.status === 201) {
        message.success("Order Placed Successfully");
        dispatch(addOrder(res.data.data));
        form.resetFields();
        dispatch(clearCartItems());
        await clearCart(token);
        setSelectedUser(null);
        setSameAsBillingExisting(false);
        setIsModalOpen(false);
        setNewAddress({
          line1: "",
          line2: "",
          city: "",
          state: "",
          postal_code: "",
          country: "",
          default: true,
        });
        setCustomerType("existing");
        setEntityType("customer");
        setIsEditing(false);
        setSelectedAddressIndex(null);
        handleClick();
        navigate(role === "sales" ? "/sales/orders" : "/admin/orders");
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Error placing order");
    }
  };

  const onNewFinish = async (values) => {
    try {
      const billingAddresses = newForm.getFieldValue("billingAddress") || [];
      const shippingAddresses = newForm.getFieldValue("shippingAddress") || [];

      const newCustomerData = {
        ...values,
        billingAddress: billingAddresses,
        shippingAddress: shippingAddresses,
      };

      const res = await newOrder(token, JSON.stringify(newCustomerData));

      if (res.status === 201) {
        message.success("Order Placed Successfully");
        dispatch(addOrder(res.data.data));
        newForm.resetFields();
        dispatch(clearCartItems());
        await clearCart(token);
        setSelectedUser(null);
        setSameAsBillingExisting(false);
        setIsModalOpen(false);
        setNewAddress({
          line1: "",
          line2: "",
          city: "",
          state: "",
          postal_code: "",
          country: "",
          default: true,
        });
        setCustomerType("existing");
        setEntityType("customer");
        setIsEditing(false);
        setSelectedAddressIndex(null);
        handleClick();
        getUsers();
        navigate(role === "sales" ? "/sales/orders" : "/admin/orders");
      }
    } catch (err) {
      message.error(err.response?.data?.message || "Error placing order");
    }
  };

  // const onFinish = async (values) => {
  //   try {
  //     console.log(values);
  //     //   const orderAddress = {
  //     //     line1: values.address.line1,
  //     //     line2: values.address.line2,
  //     //     city: values.address.city,
  //     //     state: values.address.state,
  //     //     postal_code: values.address.postal_code,
  //     //     country: values.address.country,
  //     //   };

  //     //   // Uncomment the following code to enable order creation
  //     //   const res = await createOrder(
  //     //     token,
  //     //     orderAddress,
  //     //     values.id,
  //     //     values.phone,
  //     //     values.gst_no,
  //     //     values.pan_no,
  //     //     values.billingAddress,
  //     //     values.shippingAddress
  //     //   );
  //     //   if (res.status === 201) {
  //     //     message.success("Order Placed Successfully");
  //     //     dispatch(addOrder(res.data.data));
  //     //     form.resetFields();
  //     //     dispatch(clearCartItems());
  //     //     await clearCart(token);
  //     //     handleClick();
  //     //     if (role === "sales") {
  //     //       navigate("/sales/orders");
  //     //     } else {
  //     //       navigate("/admin/orders");
  //     //     }
  //     //   }
  //   } catch (err) {
  //     message.error(err.response.data.message);
  //   }
  // };

  // const onNewFinish = async (values) => {
  //   try {
  //     // Uncomment the following code to enable order creation
  //     // return console.log(values);
  //     const res = await newOrder(token, JSON.stringify(values));
  //     if (res.status === 201) {
  //       message.success("Order Placed Successfully");
  //       dispatch(addOrder(res.data.data));
  //       form.resetFields();
  //       dispatch(clearCartItems());
  //       await clearCart(token);
  //       handleClick();
  //       if (role === "sales") {
  //         navigate("/sales/orders");
  //       } else if (role === "sales-manager") {
  //         navigate("/sales-manager/orders");
  //       } else {
  //         navigate("/admin/orders");
  //       }
  //     }
  //     getUsers();
  //   } catch (err) {
  //     message.error(err.response.data.message);
  //   }
  // };

  const getUsers = async () => {
    if (role !== "admin" && role !== "sales-manager" && role !== "sales") {
      return;
    }

    const queryParam = "customer";
    const res = await getAllUsers(queryParam, token);
    setUsers(res.data.data);
  };

  const getSalesManager = async () => {
    try {
      const res = await getAllUsers("sales-manager", token);
      setManagers(res.data.data);
      console.log("managers", res.data.data);
    } catch (err) {
      return;
    }
  };

  const getSales = async (token) => {
    try {
      const res = await getAllUsers("sales", token);
      setSales(res.data.data);
    } catch (err) {
      return;
    }
  };

  const getFilteredCustomers = () => {
    // If user is 'admin', show all customers
    if (role === "admin") {
      return users;
    }

    // If user is 'sales', only show customers assigned to this salesperson
    if (role === "sales") {
      return users.filter(
        (customer) =>
          customer.salesPerson &&
          customer.salesPerson.id.toString() === user.id.toString()
      );
    }

    // If user is 'sales-manager', show:
    // 1) Any customers whose salesPerson == this manager's ID
    // 2) Any customers whose salesPerson belongs to the manager's sales reps
    if (role === "sales-manager") {
      // 🔹 Get all sales reps (role: "sales") who have this manager as salesManager
      const managerSalesReps = sales
        .filter(
          (salesRep) =>
            salesRep.salesManager &&
            salesRep.salesManager.id.toString() === user.id.toString()
        )
        .map((salesRep) => salesRep.id.toString());

      return users.filter((customer) => {
        if (!customer.salesPerson) return false;
        const spId = customer.salesPerson.id.toString();
        return spId === user.id.toString() || managerSalesReps.includes(spId);
      });
    }

    // For any other role (like 'customer'), return empty array
    // because you said 'customer' won't see existing-customer dropdown anyway
    return [];
  };

  const resetState = () => {
    form.resetFields();
    newForm.resetFields();
    setSelectedUser(null);
    setSameAsBillingExisting(false);
    setSameAsBillingNew(false);
    setSelectedAddressIndex(null);
    setIsModalOpen(false);
    setNewAddress({
      line1: "",
      line2: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
      default: true,
    });
    setIsEditing(false);
    setCustomerType("existing");
    setEntityType("customer");
  };

  useEffect(() => {
    resetState(); // Clears form and selectedUser
  }, [user?.id, token]);

  useEffect(() => {
    if (customerType === "new") {
      newForm.resetFields();
      newForm.setFieldsValue({
        billingAddress: [],
        shippingAddress: [],
      });
    } else if (customerType === "existing" && selectedUser) {
      form.setFieldsValue({
        billingAddress: selectedUser.billingAddress || [],
        shippingAddress: selectedUser.shippingAddress || [],
      });
    }
  }, [customerType, selectedUser]);

  useEffect(() => {
    if (role !== "admin" && role !== "sales" && role !== "sales-manager")
      return;
    getUsers();
    if (role === "admin") {
      getSalesManager();
      getSales(token);
    }
    if (role === "sales-manager") getSales(token);
  }, [role, customerType]);

  useEffect(() => {
    if (role === "customer") {
      form.setFieldsValue({
        id: customerUser.id,
        fullName: `${customerUser.firstName || ""} ${
          customerUser.lastName || ""
        }`,
        email: customerUser.email || "",
        address: {
          line1: customerUser.line1 || "",
          line2: customerUser.line2 || "",
          city: customerUser.city || "",
          state: customerUser.state || "",
          postal_code: customerUser.postal_code || "",
          country: customerUser.country || "",
        },
        billingAddress: customerUser.billingAddress || [],
        shippingAddress: customerUser.shippingAddress || [],
        companyName: customerUser.companyName || "",
        pan_no: customerUser.pan_no || "",
        gst_no: customerUser.gst_no || "",
        aadhar_no: customerUser.aadhar_no || "",
        additionalContact: {
          name: customerUser.additionalContact?.name || "",
        },
        phone: customerUser.phone || "",
        alternatePhone: customerUser.alternatePhone || "",
      });
    }
  }, [customerUser, role, form]);

  const handleCustomerSelect = (value) => {
    // const selectedUser = users.find((user) => user.id === value);
    // setSelectedUser(selectedUser);
    form.resetFields();
    setSameAsBillingExisting(false);
    setSameAsBillingNew(false);
    setSelectedAddressIndex(null);
    setIsModalOpen(false);
    setIsEditing(false);

    const selectedUser = users.find((user) => user.id === value);
    setSelectedUser(selectedUser);
    if (selectedUser) {
      form.setFieldsValue({
        id: selectedUser.id,
        fullName: `${selectedUser.firstName || ""} ${
          selectedUser.lastName || ""
        }`,
        firstName: selectedUser.firstName || "",
        lastName: selectedUser.lastName || "",
        email: selectedUser.email || "",
        address: {
          line1: selectedUser.address?.line1 || "",
          line2: selectedUser.address?.line2 || "",
          city: selectedUser.address?.city || "",
          state: selectedUser.address?.state || "",
          postal_code: selectedUser.address?.postal_code || "",
          country: selectedUser.address?.country || "",
        },
        billingAddress: selectedUser.billingAddress || [],
        shippingAddress: selectedUser.shippingAddress || [],
        companyName: selectedUser.companyName || "",
        pan_no: selectedUser.pan_no || "",
        gst_no: selectedUser.gst_no || "",
        aadhar_no: selectedUser.aadhar_no || "",
        additionalContact: {
          name: selectedUser.additionalContact?.name || "",
        },
        phone: selectedUser.phone || "",
        alternatePhone: selectedUser.alternatePhone || "",
      });
    }
  };

  useEffect(() => {
    getAllCompanies();
  }, [users]);

  const addCompany = async (e) => {
    e.preventDefault();
    if (newCompany && !companies.includes(newCompany)) {
      setCompanies((prev) => [...prev, newCompany]);
      form.setFieldsValue({ companyName: newCompany }); // Automatically select the new category
    }
    setNewCompany("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const getAllCompanies = async () => {
    const companies = await getCompanies(token);
    setCompanies(companies.data.data);
  };
  console.log("sales", sales);
  console.log("user", user);
  return (
    <>
      {role !== "customer" && (
        <Radio.Group
          onChange={handleCustomerTypeChange}
          value={customerType}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <Radio.Button value="existing">Existing Customer</Radio.Button>
          <Radio.Button value="new">New Customer</Radio.Button>
        </Radio.Group>
      )}

      {customerType === "existing" && (
        <div
          style={{
            maxWidth: "800px",
            margin: "20px auto",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            background: "#fff",
          }}
        >
          <Form
            form={form}
            onFinish={onFinish}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            // layout="vertical"
          >
            <Title level={2} style={{ textAlign: "center" }}>
              Create Order
            </Title>
            {/* Hidden field to store the user ID */}
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
            <Form.Item name="companyName" label="Company">
              {/* <Input value={customerUser.companyName} /> */}
              <Select
                showSearch
                placeholder="Select a Customer"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={getFilteredCustomers()
                  .filter((user) => user.role === "customer")
                  .map((user) => ({
                    value: `${user.id}`,
                    label: `${user.companyName || user.role}`,
                  }))}
                onSelect={handleCustomerSelect}
              />
            </Form.Item>
            {role === "customer" && (
              <Form.Item
                name="fullName"
                label="Customer"
                rules={[
                  { required: true, message: "Please select a Customer" },
                ]}
                initialValue={`${customerUser.firstName || ""} ${
                  customerUser.lastName || ""
                }`}
              >
                <Input placeholder="Name" disabled />
              </Form.Item>
            )}
            {role !== "customer" && (
              <>
                <Form.Item
                  name="fullName"
                  label="Customer"
                  rules={[
                    { required: true, message: "Please select a Customer" },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Customer"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={getFilteredCustomers()
                      .filter(
                        (user) =>
                          user.role === "customer" &&
                          (user.firstName || user.lastName)
                      )
                      .map((user) => ({
                        value: `${user.id}`,
                        label: `${user.firstName || ""} ${user.lastName || ""}`,
                      }))}
                    onSelect={handleCustomerSelect}
                  />
                </Form.Item>

                <Divider>Form</Divider>

                <Form.Item
                  name="companyName"
                  label="Company Name"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Please input your Company Name!",
                  //   },
                  // ]}
                >
                  <Input placeholder="Company" />
                </Form.Item>
                <Form.Item
                  name="firstName"
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your First Name!",
                    },
                  ]}
                >
                  <Input placeholder="First Name" />
                </Form.Item>
                <Form.Item
                  name="lastName"
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Last Name!",
                    },
                  ]}
                >
                  <Input placeholder="Last Name" />
                </Form.Item>
              </>
            )}

            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            {/* Option to Add More Billing Addresses */}
            <Form.Item
              name="billingAddressSelected"
              label="Billing Address"
              rules={[
                {
                  required: true,
                  message: "Please select a billing address!",
                },
              ]}
            >
              <Select
                placeholder="Select Billing Address"
                value={form.getFieldValue("billingAddressSelected")}
                dropdownMatchSelectWidth={true} // Ensures dropdown width matches Select component
                style={{
                  whiteSpace: "pre-wrap", // Ensures multiline wrapping
                  wordWrap: "break-word",
                  height: "auto", // Allows select to resize dynamically
                  minHeight: "40px", // Set a reasonable minimum height
                  padding: "8px", // Prevents text from getting cut off
                  display: "flex",
                  alignItems: "center", // Keeps text properly aligned
                }}
                dropdownStyle={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  maxWidth: "100%",
                }}
                onChange={(value) =>
                  handleAddressSelect(value, "billingAddress", form)
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space
                      style={{
                        padding: "0 8px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="link"
                        onClick={() => {
                          setIsAddingBilling(true);
                          setIsModalOpen(true);
                        }}
                      >
                        + Add Billing Address
                      </Button>
                    </Space>
                  </>
                )}
                options={[
                  // Include billing addresses (if available)
                  ...(form.getFieldValue("billingAddress") || []).map(
                    (addr, index) => {
                      // Remove empty values and join the remaining address parts
                      const formattedAddress = [
                        addr.line1,
                        addr.line2,
                        addr.city,
                        addr.state,
                        addr.postal_code,
                        addr.country,
                      ]
                        .filter((part) => part) // Remove undefined/null/empty values
                        .join(", ");

                      return {
                        value: `billing-${index}`,
                        label: (
                          <div
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}
                          >
                            {formattedAddress}
                            <Button
                              type="text"
                              icon={<EditOutlined />}
                              onClick={() =>
                                handleEditAddress(index, "billingAddress")
                              }
                            />
                          </div>
                        ),
                      };
                    }
                  ),
                  // Include main address (if available)
                  ...(form.getFieldValue("billingAddress")?.length
                    ? [] // Don't include the main address if billingAddress exists
                    : form.getFieldValue("address")
                    ? [
                        {
                          value: "main-address",
                          label: (
                            <div
                              style={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                              }}
                            >
                              {[
                                form.getFieldValue("address").line1,
                                form.getFieldValue("address").line2,
                                form.getFieldValue("address").city,
                                form.getFieldValue("address").state,
                                form.getFieldValue("address").postal_code,
                                form.getFieldValue("address").country,
                              ]
                                .filter((part) => part) // Remove empty values
                                .join(", ")}
                              <Button
                                type="text"
                                icon={<EditOutlined />}
                                onClick={() =>
                                  handleEditAddress(null, "address")
                                }
                              />
                            </div>
                          ),
                        },
                      ]
                    : []),
                ]}
              />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 7, span: 18 }}>
              <Checkbox
                onChange={handleSameAsBillingChangeExisting}
                checked={sameAsBillingExisting}
              >
                Same as Billing Address
              </Checkbox>
            </Form.Item>

            <Form.Item name="shippingAddressSelected" label="Shipping Address">
              <Select
                placeholder="Select Shipping Address"
                value={form.getFieldValue("shippingAddressSelected")}
                onChange={(value) =>
                  handleAddressSelect(value, "shippingAddress", form)
                }
                disabled={sameAsBillingExisting}
                dropdownMatchSelectWidth={true} // Ensures dropdown width matches Select component
                style={{
                  whiteSpace: "pre-wrap", // Ensures multiline wrapping
                  wordWrap: "break-word",
                  height: "auto", // Allows select to resize dynamically
                  minHeight: "40px", // Set a reasonable minimum height
                  padding: "8px", // Prevents text from getting cut off
                  display: "flex",
                  alignItems: "center", // Keeps text properly aligned
                }}
                dropdownStyle={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  maxWidth: "100%",
                }}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space
                      style={{
                        padding: "0 8px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="link"
                        onClick={() => {
                          setIsAddingBilling(false);
                          setIsModalOpen(true);
                        }}
                        disabled={sameAsBillingExisting}
                      >
                        + Add Shipping Address
                      </Button>
                    </Space>
                  </>
                )}
                options={[
                  ...(form.getFieldValue("shippingAddress") || []).map(
                    (addr, index) => {
                      // Remove empty values and join the remaining address parts
                      const formattedAddress = [
                        addr.line1,
                        addr.line2,
                        addr.city,
                        addr.state,
                        addr.postal_code,
                        addr.country,
                      ]
                        .filter((part) => part) // Remove undefined/null/empty values
                        .join(", ");

                      return {
                        value: `shipping-${index}`,
                        label: (
                          <div
                            style={{
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                            }}
                          >
                            {formattedAddress}
                            <Button
                              type="text"
                              icon={<EditOutlined />}
                              onClick={() =>
                                handleEditAddress(index, "shippingAddress")
                              }
                              disabled={sameAsBillingExisting}
                            />
                          </div>
                        ),
                      };
                    }
                  ),
                ]}
              />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Phone"
              rules={[{ required: true, message: "Please input your phone!" }]}
            >
              <Input placeholder="phone" />
            </Form.Item>
            <Form.Item
              name={["additionalContact", "name"]}
              label="Additional contact name"
            >
              <Input placeholder="Optional" />
            </Form.Item>
            <Form.Item
              name="alternatePhone"
              label="Additional contact phone"
            >
              <Input placeholder="Optional" />
            </Form.Item>
            <Form.Item name="pan_no" label="PAN No">
              <Input placeholder="Optional" />
            </Form.Item>
            <Form.Item name="gst_no" label="GST No">
              <Input placeholder="GST Number" />
            </Form.Item>
            <Form.Item name="aadhar_no" label="Aadhar card number">
              <Input placeholder="Optional" />
            </Form.Item>
            <Form.Item
              wrapperCol={{ offset: 0, span: 24 }}
              style={{ textAlign: "center" }}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 20 }}
              >
                Create Order
              </Button>
              <Button type="default" htmlType="button" onClick={handleClick}>
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
      {customerType === "new" && (
        <div
          style={{
            maxWidth: "600px",
            margin: "20px auto",
            padding: "20px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            borderRadius: "8px",
            background: "#fff",
          }}
        >
          <Form
            form={newForm}
            onFinish={onNewFinish}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 18 }}
          >
            <Title level={2} style={{ textAlign: "center" }}>
              Create Order
            </Title>
            {/* Hidden field to store the user ID */}
            <Form.Item
              name="entityType"
              label="Entity Type"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select Entity Type"
                onChange={handleEntityTypeChange}
              >
                <Select.Option value="customer">Customer</Select.Option>
                <Select.Option value="company">Company</Select.Option>
              </Select>
            </Form.Item>
            {/* Conditional fields based on entity type */}
            {entityType === "company" && (
              <>
                <Form.Item name="companyName" label="Company">
                  <Select
                    showSearch
                    placeholder="custom dropdown render"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: "8px 0" }} />
                        <Space style={{ padding: "0 8px 4px" }}>
                          <Input
                            placeholder="Please enter item"
                            ref={inputRef}
                            value={newCompany}
                            onChange={onCompanyChange}
                            onKeyDown={(e) => e.stopPropagation()} // Prevents closing the dropdown when pressing keys
                          />
                          <Button
                            type="text"
                            icon={<PlusOutlined />}
                            onClick={addCompany}
                          >
                            Add item
                          </Button>
                        </Space>
                      </>
                    )}
                    options={companies?.map((companyName) => ({
                      label: companyName,
                      value: companyName,
                    }))}
                  />
                </Form.Item>
              </>
            )}
            {/* {role === "admin" && (
              <Form.Item
                name="salesManager"
                label="Manager"
                rules={[{ required: true, message: "Please select a Manager" }]}
              >
                <Select
                  showSearch
                  placeholder="Assign Sales Person"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  // options={managers
                  //   .filter((user) => user.role === "sales-manager")
                  //   .map((user) => ({
                  //     value: `${user.id}`,
                  //     label: `${user.firstName || ""} ${user.lastName || ""}`,
                  //   }))}
                  // onSelect={handleCustomerSelect}
                  onSelect={handleManagerSelect}
                >
                  <>
                    <Option
                      key={user.id}
                      value={user.id}
                    >{`${user.firstName || ""} ${user.lastName || ""}`}</Option>
                    {managers.map((manager) => (
                      <Option key={manager.id} value={`${manager.id}`}>
                        {`${manager.firstName || ""} ${manager.lastName || ""}`}
                      </Option>
                    ))}
                  </>
                </Select>
              </Form.Item>
            )} */}
            {(role === "sales-manager" || role === "admin") && (
              // <Form.Item
              //   name="salesPerson"
              //   label="Sale Person"
              //   rules={[
              //     { required: true, message: "Please select a Sales Person" },
              //   ]}
              // >
              //   <Select
              //     showSearch
              //     placeholder="Assign Sales Person"
              //     filterOption={(input, option) =>
              //       (option?.label ?? "")
              //         .toLowerCase()
              //         .includes(input.toLowerCase())
              //     }
              //     // options={sales
              //     //   // .filter((user) => user.)
              //     //   .filter(
              //     //     (user) =>
              //     //       user.salesManager &&
              //     //       user.salesManager["id"] === selectedManagerId
              //     //   )
              //     //   .map((user) => ({
              //     //     value: `${user.id}`,
              //     //     label: `${user.firstName || ""} ${user.lastName || ""}`,
              //     //   }))}
              //     // onSelect={handleCustomerSelect}
              //   >
              //     <Option key={user.id} value={user.id}>{`${
              //       user.firstName || ""
              //     } ${user.lastName || ""}`}</Option>
              //     {role === "admin" &&
              //       sales
              //         // .filter(
              //         //   (user) =>
              //         //     user.salesManager &&
              //         //     user.salesManager["id"] === selectedManagerId
              //         // )
              //         .filter(
              //           (user) =>
              //             user.role === "sales" || user.role === "sales-manager"
              //         )
              //         .map((salesPerson) => (
              //           <Option
              //             key={salesPerson.id}
              //             value={`${salesPerson.id}`}
              //           >
              //             {`${salesPerson.firstName || ""} ${
              //               salesPerson.lastName || ""
              //             }`}
              //           </Option>
              //         ))}
              //     {role === "sales-manager" &&
              //       sales
              //         .filter((salesPerson) => salesPerson.role === "sales")
              //         .map((salesPerson) => (
              //           <Option
              //             key={salesPerson.id}
              //             value={`${salesPerson.id}`}
              //           >
              //             {`${salesPerson.firstName || ""} ${
              //               salesPerson.lastName || ""
              //             }`}
              //           </Option>
              //         ))}
              //   </Select>
              // </Form.Item>
              <Form.Item
                name="salesPerson"
                label="Sale Person"
                rules={[
                  { required: true, message: "Please select a Sales Person" },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Assign Sales Person"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  options={(role === "admin"
                    ? [...sales, ...managers]
                    : [...sales.filter((sp) => sp.role === "sales"), user]
                  ).map((user) => ({
                    value: `${user.id}`,
                    label: `${user.firstName || ""} ${user.lastName || ""} (${
                      user.role
                    })`,
                  }))}
                />
              </Form.Item>
            )}
            <Form.Item
              name="firstName"
              label="FirstName"
              rules={[{ required: true, message: "Please enter FirstName" }]}
            >
              <Input placeholder="FirstName" />
            </Form.Item>
            <Form.Item
              name="lastName"
              label="LastName"
              rules={[{ required: true, message: "Please enter LastName" }]}
            >
              <Input placeholder="LastName" />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input placeholder="Email" />
            </Form.Item>

            <Form.Item
              name="billingAddressSelected"
              label="Billing Address"
              rules={[
                { required: true, message: "Please select a billing address!" },
              ]}
            >
              <Select
                placeholder="Select Billing Address"
                value={newForm.getFieldValue("billingAddressSelected")}
                onChange={(value) =>
                  handleAddressSelect(value, "billingAddress", newForm)
                }
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space
                      style={{
                        padding: "0 8px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="link"
                        onClick={() => {
                          setIsAddingBilling(true);
                          setIsModalOpen(true);
                        }}
                      >
                        + Add Billing Address
                      </Button>
                    </Space>
                  </>
                )}
                options={[
                  ...(newForm.getFieldValue("billingAddress") || []).map(
                    (addr, index) => ({
                      value: `billing-${index}`,
                      label: (
                        <div
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          }}
                        >
                          {`${addr.line1}, ${addr.city}, ${addr.state}, ${addr.country}`}
                          <Button
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() =>
                              handleEditAddress(index, "billingAddress")
                            }
                          />
                        </div>
                      ),
                    })
                  ),
                ]}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 7, span: 18 }}>
              <Checkbox
                onChange={handleSameAsBillingChangeNew}
                checked={sameAsBillingNew}
              >
                Same as Billing Address
              </Checkbox>
            </Form.Item>
            <Form.Item name="shippingAddressSelected" label="Shipping Address">
              <Select
                placeholder="Select Shipping Address"
                value={newForm.getFieldValue("shippingAddressSelected")}
                onChange={(value) =>
                  handleAddressSelect(value, "shippingAddress", newForm)
                }
                disabled={sameAsBillingNew}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <Divider style={{ margin: "8px 0" }} />
                    <Space
                      style={{
                        padding: "0 8px",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="link"
                        onClick={() => {
                          setIsAddingBilling(false);
                          setIsModalOpen(true);
                        }}
                      >
                        + Add Shipping Address
                      </Button>
                    </Space>
                  </>
                )}
                options={[
                  ...(newForm.getFieldValue("shippingAddress") || []).map(
                    (addr, index) => ({
                      value: `shipping-${index}`,
                      label: (
                        <div
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          }}
                        >
                          <span>{`${addr.line1}, ${addr.city}, ${addr.state}, ${addr.country}`}</span>
                          <Button
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() =>
                              handleEditAddress(index, "shippingAddress")
                            }
                            disabled={sameAsBillingNew}
                          />
                        </div>
                      ),
                    })
                  ),
                ]}
              />
            </Form.Item>

            <Form.Item
              name="phone"
              label="Phone"
              rules={[{ required: true, message: "Please input your phone!" }]}
            >
              <Input placeholder="phone" />
            </Form.Item>
            <Form.Item
              name={["additionalContact", "name"]}
              label="Additional contact name"
            >
              <Input placeholder="Optional" />
            </Form.Item>
            <Form.Item
              name="alternatePhone"
              label="Additional contact phone"
            >
              <Input placeholder="Optional" />
            </Form.Item>
            {entityType === "company" && (
              <>
                <Form.Item name="pan_no" label="PAN No">
                  <Input />
                </Form.Item>
                <Form.Item name="gst_no" label="GST No">
                  <Input />
                </Form.Item>
                <Form.Item name="aadhar_no" label="Aadhar card number">
                  <Input placeholder="Optional" />
                </Form.Item>
              </>
            )}
            {entityType !== "company" && (
              <>
                <Form.Item name="pan_no" label="PAN No">
                  <Input placeholder="Optional" />
                </Form.Item>
                <Form.Item name="gst_no" label="GST No">
                  <Input placeholder="GST Number" />
                </Form.Item>
              </>
            )}
            <Form.Item
              wrapperCol={{ offset: 0, span: 24 }}
              style={{ textAlign: "center" }}
            >
              <Button
                type="primary"
                htmlType="submit"
                style={{ marginRight: 20 }}
              >
                Create Order
              </Button>
              <Button type="default" htmlType="button" onClick={handleClick}>
                Cancel
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}

      <Modal
        title={isEditing ? "Edit Address" : "Add New Address"}
        open={isModalOpen}
        onOk={handleModalOk}
        // onOk={() => {
        //   if (
        //     !newAddress.line1 ||
        //     !newAddress.city ||
        //     !newAddress.state ||
        //     !newAddress.country
        //   ) {
        //     message.error("Please fill all required fields!");
        //     return;
        //   }

        //   // Determine which form to update (new or existing customer)
        //   const activeForm = customerType === "existing" ? form : newForm;

        //   // Determine the field being updated (Billing or Shipping)
        //   const fieldToUpdate = isAddingBilling
        //     ? "billingAddress"
        //     : "shippingAddress";

        //   // Get the current list of addresses for the selected field
        //   const updatedAddresses = [
        //     ...(activeForm.getFieldValue(fieldToUpdate) || []),
        //     newAddress,
        //   ];

        //   // Update only the intended address field
        //   activeForm.setFieldsValue({
        //     [fieldToUpdate]: updatedAddresses,
        //   });

        //   // Reset newAddress after adding
        //   setNewAddress({
        //     line1: "",
        //     line2: "",
        //     city: "",
        //     state: "",
        //     postal_code: "",
        //     country: "",
        //   });

        //   setIsModalOpen(false);
        //   message.success("New Address Added!");
        // }}
        onCancel={() => {
          setIsModalOpen(false);
          setIsEditing(false);
          setSelectedAddressIndex(null);
        }}
      >
        <Form layout="vertical">
          <Form.Item label="Line 1" required>
            <Input
              value={newAddress.line1}
              onChange={(e) =>
                setNewAddress({ ...newAddress, line1: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="Line 2">
            <Input
              value={newAddress.line2}
              onChange={(e) =>
                setNewAddress({ ...newAddress, line2: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="City" required>
            <Input
              value={newAddress.city}
              onChange={(e) =>
                setNewAddress({ ...newAddress, city: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="State" required>
            <Input
              value={newAddress.state}
              onChange={(e) =>
                setNewAddress({ ...newAddress, state: e.target.value })
              }
            />
          </Form.Item>
          <Form.Item label="Zip Code">
            <Input
              value={newAddress.postal_code}
              onChange={(e) =>
                setNewAddress({
                  ...newAddress,
                  postal_code: e.target.value,
                })
              }
            />
          </Form.Item>
          <Form.Item label="Country" required>
            <Input
              value={newAddress.country}
              onChange={(e) =>
                setNewAddress({ ...newAddress, country: e.target.value })
              }
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateOrderForm;
